if (!customElements.get('lsg-products-grid')) {
    customElements.define('lsg-products-grid', class LSGProductsGrid extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                collections: ".js-lsg-products-grid-filter-collections",
                collectionsBlocks: ".js-lsg-products-grid-filter-collection",
                sortBy: ".js-lsg-products-grid-filter-sort-by",
                products: '.js-lsg-products-grid-filter-product',
                filterToggle: '.js-lsg-products-grid-filter-btn',
                filterToggleAll: '.js-lsg-products-grid-filter-btn-all',
                body: "body",
                productsGroup: ".js-lsg-products-grid-group"
            };
            this.sortBy = this.querySelectorAll(this.selectors.sortBy);
            this.filterToggle = this.querySelectorAll(this.selectors.filterToggle);
            this.filterToggleAll = this.querySelectorAll(this.selectors.filterToggleAll);

            this.body = document.querySelector(this.selectors.body);
            this.collections = document.querySelectorAll(this.selectors.collections);
            this.dataCollections = [];
            this.initCollectionsBlock();
            this.init();
        }

        initCollectionsBlock() {
            this.dataCollections = [];
            this.collectionsBlocks = this.querySelectorAll(this.selectors.collectionsBlocks);
            this.collectionsBlocks.forEach((collection) => {
                let data = [];
                collection.querySelectorAll(this.selectors.products).forEach((el) => {
                    data.push({
                        element: el,
                        created: Number(new Date(el.getAttribute('data-created'))),
                        price: parseInt(el.getAttribute('data-price'), 10),
                        title: el.getAttribute('data-title'),
                        index: parseInt(el.getAttribute('data-index'), 10),
                        collections: el.getAttribute('data-collections').split(',')
                    })
                });

                this.dataCollections.push({
                    collection: collection,
                    products: data
                });
            });
        }

        sortProducts(sortValue) {
            this.dataCollections.forEach((colEl) => {
                let newProducts = [...colEl.products];
                switch (sortValue) {
                    case 'manual': newProducts.sort((a, b) => (a.index > b.index ? 1 : -1)); break;
                    case 'created-descending': newProducts.sort((a, b) => (b.created > a.created ? 1 : -1)); break;
                    case 'price-ascending': newProducts.sort((a, b) => (a.price > b.price ? 1 : -1)); break;
                    case 'price-descending': newProducts.sort((a, b) => (b.price > a.price ? 1 : -1)); break;
                    case 'title-ascending': newProducts.sort((a, b) => (a.title > b.title ? 1 : -1)); break;
                    case 'title-descending': newProducts.sort((a, b) => (b.title > a.title ? 1 : -1)); break;
                }
                const grid = colEl.collection;
                grid.innerHTML = '';
                newProducts.forEach((product) => grid.append(product.element));
            });
        }

        /**
         * Logic to filter products and update URL
         * @param {HTMLElement} el - The clicked button or the button matching the hash
         * @param {Boolean} updateUrl - Whether to update the browser URL hash
         */
        filterProducts(el, updateUrl = true) {
            this.filterToggle.forEach(item => item.classList.remove('is-active'));
            this.filterToggleAll.forEach(item => item.classList.remove('is-active'));

            el.classList.add('is-active');
            const handle = el.getAttribute('data-handle');
            const isAll = !handle || handle === 'all' || el.classList.contains('js-lsg-products-grid-filter-btn-all');

            // 1. Update the URL Hash
            if (updateUrl) {
                if (isAll) {
                    // Removes the #hash entirely from the URL
                    history.replaceState(null, null, window.location.pathname + window.location.search);
                } else {
                    // Sets the hash to the current handle
                    history.replaceState(null, null, `#${handle}`);
                }
            }

            // 2. Filter products display
            this.querySelectorAll(this.selectors.products).forEach((product) => {
                const collections = product.getAttribute('data-collections').split(',');
                if (isAll || collections.includes(handle)) {
                    product.classList.remove('is-hidden');
                } else {
                    product.classList.add('is-hidden');
                }
            });

            // 3. Filter group display
            this.querySelectorAll(this.selectors.productsGroup).forEach((group) => {
                const collections = group.getAttribute('data-collections').split(',');
                if (isAll || collections.includes(handle)) {
                    group.classList.remove('is-hidden');
                } else {
                    group.classList.add('is-hidden');
                }
            });
        }

        // Checks URL hash on load or on back/forward navigation
        checkHash() {
            const hash = window.location.hash.replace('#', '');
            if (!hash) {
                // If no hash, trigger "All" button
                const allBtn = this.querySelector(this.selectors.filterToggleAll);
                if (allBtn) this.filterProducts(allBtn, false);
                return;
            };

            const targetBtn = this.querySelector(`[data-handle="${hash}"]`);
            if (targetBtn) {
                this.filterProducts(targetBtn, false); // false because the hash is already in the URL
            }
        }

        init() {
            // Sort listener
            this.sortBy.forEach(el => {
                el.addEventListener('change', () => this.sortProducts(el.value));
            });

            // Click listeners for specific handles
            this.filterToggle.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.filterProducts(el, true);
                });
            });

            // Click listeners for "All"
            this.filterToggleAll.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.filterProducts(el, true);
                });
            });

            // Run on page load
            this.checkHash();

            // Run when user clicks back/forward browser buttons
            window.addEventListener('hashchange', () => this.checkHash());
        }
    });
}